<template>
  <div class="configuration-page">
    <div class="header">
      <div class="back-btn" @click="goBack">
        <el-icon :size="20"><ArrowLeft /></el-icon>
        <span class="back-text">返回</span>
      </div>
    </div>

    <div class="content">
      <div class="selections-container">
        <!-- 配件信息 -->
        <div class="selections-info">
          <h3>配置清单</h3>
          <div class="codes-info" v-if="codeString">
            <span class="codes-label">配置编码：</span>
            <div class="codes-box" @click="copyCodes" title="点击复制配置编码">{{ codeString }}</div>
            <el-button link size="small" type="primary" @click="copyCodes">复制</el-button>
          </div>
          <div class="selections-list" v-if="selections.length">
            <div
              v-for="(item, index) in selections"
              :key="index"
              class="selection-item"
            >
              <div class="step-name">{{ item.stepName }}</div>
              <div class="item-info" @click="openDetail(item)">
                <img
                  style="width: 100px"
                  :src="item.goodsResult.goodsInfo.thumb"
                  alt=""
                />
                <div class="item-info-content">
                  <div class="item-name">
                    {{ item.goodsName || "未知商品" }}
                  </div>
                  <div class="item-price">价格: ¥{{ item.unitPrice }}</div>
                </div>
                <el-icon style="margin-left: auto" :size="20"
                  ><ArrowRight
                /></el-icon>
              </div>
            </div>
          </div>
          <!-- 空状态 -->
          <div v-else class="empty-state">
            <el-empty description="暂无配件数据">
              <el-button type="primary" @click="goBack">返回选择配件</el-button>
            </el-empty>
          </div>

          <div class="total-info">
            <div>总价:</div>
            <div class="total-price">¥{{ totalPrice }}</div>
          </div>
        </div>
      </div>
      <div class="address-info">
        <div class="address-info-header">
          <h2
            :style="{ fontWeight: isNewAddress ? 'bold' : 'normal' }"
            style="cursor: pointer"
            @click="isNewAddress = true"
          >
            创建新地址
          </h2>
          <h2
            :style="{ fontWeight: isNewAddress ? 'normal' : 'bold' }"
            style="cursor: pointer"
            @click="isNewAddress = false"
          >
            选择收货地址
          </h2>
        </div>
        <div class="address-box">
          <el-form
            v-if="isNewAddress"
            class="address-form"
            :model="addressForm"
            :rules="addressRules"
            ref="addressFormRef"
            label-position="top"
          >
            <el-form-item label="收货人" prop="consignee">
              <el-input
                size="large"
                v-model="addressForm.consignee"
                placeholder="请输入收货人"
              />
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
              <el-input
                size="large"
                v-model="addressForm.mobile"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item label="省/直辖市" prop="provinceCode">
              <el-select
                clearable
                size="large"
                v-model="addressForm.provinceCode"
                placeholder="请选择省/直辖市"
                @change="handleProvinceChange"
              >
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="市/州" prop="cityCode">
              <el-select
                :disabled="!addressForm.provinceCode"
                clearable
                size="large"
                v-model="addressForm.cityCode"
                placeholder="请选择市/州"
                @change="handleCityChange"
              >
                <el-option
                  v-for="item in cityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="区/县" prop="regionCode">
              <el-select
                :disabled="!addressForm.cityCode"
                clearable
                size="large"
                v-model="addressForm.regionCode"
                placeholder="请选择区/县"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input
                size="large"
                v-model="addressForm.address"
                placeholder="请输入详细地址"
              />
            </el-form-item>
            <el-form-item label="邮政编码" prop="zipCode">
              <el-input
                size="large"
                v-model="addressForm.zipCode"
                placeholder="请输入邮政编码"
              />
            </el-form-item>
            <el-form-item label="买家留言">
              <el-input
                resize="none"
                type="textarea"
                size="large"
                :rows="4"
                v-model="addressForm.remark"
                placeholder="选填输入"
              />
            </el-form-item>
          </el-form>
          <div class="address-list" v-else>
            <div
              class="address-item"
              v-for="(address, index) in addressList"
              :key="index"
              :class="{ active: selectedAddressId === address.id }"
              @click="selectAddress(address)"
            >
              <div class="address-content">
                <div class="address-header">
                  <span class="consignee">{{ address.consignee }}</span>
                  <span class="phone">{{ address.phone }}</span>
                  <span class="default-tag" v-if="address.isDefault">默认</span>
                </div>
                <div class="address-detail">
                  {{ address.province }} {{ address.city }} {{ address.area }}
                  {{ address.address }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="address-info-footer">
          <div>请选择支付方式</div>
          <div>
            <el-radio-group v-model="paymentMethod">
              <el-radio size="large" label="wepay">
                <div class="payment-option">
                  <img
                    src="@/assets/svgs/wepay.svg"
                    alt="微信支付"
                    class="payment-icon"
                  />
                  <span>微信支付</span>
                </div>
              </el-radio>
              <el-radio size="large" label="alipay">
                <div class="payment-option">
                  <img
                    src="@/assets/svgs/alipay.svg"
                    alt="支付宝支付"
                    class="payment-icon"
                  />
                  <span>支付宝支付</span>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
          <el-button
            @click="submitOrder"
            size="large"
            color="#007c4f"
            type="primary"
            round
          >
            提交订单
          </el-button>
        </div>
      </div>
    </div>
  </div>

  <GoodsDetail
    v-model:show="goodDetailVisible"
    v-if="goodDetailVisible"
    :detailId="detailId"
  />
  
  <PayQrCodeDialog ref="payQrCodeDialogRef" @timeout="payTimeoutHandle" />
</template>

<script setup>
import { ref, computed, onMounted, defineAsyncComponent, useTemplateRef, unref } from "vue";
import { useRouter, useRoute } from "vue-router";
import provinceData from "@/utils/province";
import cityData from "@/utils/city";
import areaData from "@/utils/area";
import { getAddressListApi, submitOrderApi, payApi } from "@/api/custom";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import PayQrCodeDialog from '@/components/PayQrCodeDialog.vue'
import { saveAddress } from "@/api/user";
const GoodsDetail = defineAsyncComponent(() =>
  import("@/views/GoodsDetail.vue")
);

const router = useRouter();
const route = useRoute();
const selections = ref([]);

// 计算总价
const totalPrice = computed(() => {
  return selections.value.reduce((total, item) => {
    return total + (item.unitPrice || 0);
  }, 0);
});

const codeString = computed(() => {
  const codes = selections.value
    .map((item) => item.skuCode || item.goodsSku?.skuCode || item.goodsCode || item.goodsResult?.goodsInfo?.skuCode)
    .filter(Boolean);
  if (codes.length <= 1) return "";
  return codes.slice(1).join("-");
});

const copyCodes = async () => {
  const text = codeString.value;
  if (!text) {
    ElMessage.warning("暂无可复制的配置编码");
    return;
  }
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success("已复制到剪贴板");
  } catch (err) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      ElMessage.success("已复制到剪贴板");
    } catch (e) {
      ElMessage.error("复制失败，请手动复制");
    } finally {
      document.body.removeChild(textarea);
    }
  }
};
// 返回上一页
const goBack = () => {
  router.back();
};

// 页面加载时获取传递的参数
onMounted(() => {
  // 优先从localStorage获取数据
  const storedSelections = sessionStorage.getItem(route.query.sessionId);

  if (storedSelections) {
    try {
      selections.value = JSON.parse(storedSelections);
    } catch (error) {
      console.error("解析localStorage中的selections失败:", error);
    }
  }
  console.log(selections.value, "====selections.value====");
});

const goodDetailVisible = ref(false);
const detailId = ref(0);
const openDetail = (item) => {
  detailId.value = item.id;
  goodDetailVisible.value = true;
};

const isNewAddress = ref(true);
// 创建新地址
const addressForm = ref({
  consignee: "",
  mobile: "",
  provinceCode: "",
  cityCode: "",
  regionCode: "",
  address: "",
  zipCode: "",
  remark: "",
});

const addressRules = ref({
  consignee: [{ required: true, message: "请输入收货人", trigger: "blur" }],
  mobile: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号",
      trigger: "blur",
    },
  ],
  provinceCode: [
    { required: true, message: "请选择省/直辖市", trigger: "change" },
  ],
  cityCode: [{ required: true, message: "请选择市/州", trigger: "change" }],
  regionCode: [{ required: true, message: "请选择区/县", trigger: "change" }],
  address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
});

// 省市区数据
const provinceOptions = ref(provinceData);
const cityOptions = ref([]);
const regionOptions = ref([]);

// 省份选择变化时，更新城市列表
const handleProvinceChange = (provinceValue) => {
  addressForm.value.cityCode = "";
  addressForm.value.regionCode = "";
  cityOptions.value = [];
  regionOptions.value = [];

  if (provinceValue) {
    const provinceIndex = provinceData.findIndex(
      (p) => p.value === provinceValue
    );
    if (provinceIndex !== -1) {
      cityOptions.value = cityData[provinceIndex] || [];
    }
  }
};

// 城市选择变化时，更新区域列表
const handleCityChange = (cityValue) => {
  addressForm.value.regionCode = "";
  regionOptions.value = [];

  if (cityValue && addressForm.value.provinceCode) {
    const provinceIndex = provinceData.findIndex(
      (p) => p.value === addressForm.value.provinceCode
    );
    if (provinceIndex !== -1) {
      const cityIndex = cityData[provinceIndex]?.findIndex(
        (c) => c.value === cityValue
      );
      if (cityIndex !== -1) {
        regionOptions.value = areaData[provinceIndex]?.[cityIndex] || [];
      }
    }
  }
};

// 选择地址列表
const addressList = ref();
const getAddressList = async () => {
  const res = await getAddressListApi();
  addressList.value = res;

  if (Array.isArray(addressList.value) && addressList.value.length > 0) {
    // 自动切换到选择收货地址
    isNewAddress.value = false;

    // 优先默认地址，否则选第一条
    const defaultItem = addressList.value.find((item) => item.isDefault);
    if (defaultItem) {
      selectAddress(defaultItem);
    } else {
      selectAddress(addressList.value[0]);
    }
  }
};
getAddressList();
const selectedAddressId = ref();
const selectAddress = (address) => {
  selectedAddressId.value = address.id;
};

const payQrCodeDialogRef = useTemplateRef('payQrCodeDialogRef')
const addressFormRef = ref();
const paymentMethod = ref("alipay");
const submitOrder = async () => {
  // 若是新地址则校验表单
  if (isNewAddress.value) {
    try {
      const valid = await addressFormRef.value.validate();
      if (!valid) {
        return;
      }
    } catch (err) {
      // element-plus 校验失败时可能抛出字段错误对象，直接中断后续逻辑
      return;
    }
  }
  const selectedAddress = addressList.value.find(
    (item) => item.id === selectedAddressId.value
  );
  // 组装参数
  let params = {
    skuParams: selections.value.map((item) => {
      return {
        skuid: item.goodsSku.id,
        num: 1,
      };
    }),
    receiveParam: isNewAddress.value
      ? {
          ...addressForm.value,
          province: provinceOptions.value.find(
            (item) => item.value === addressForm.value.provinceCode
          )?.label,
          city: cityOptions.value.find(
            (item) => item.value === addressForm.value.cityCode
          )?.label,
          region: regionOptions.value.find(
            (item) => item.value === addressForm.value.regionCode
          )?.label,
        }
      : {
          ...selectedAddress,
        },
    remark: addressForm.value.remark,
    sessionId: route.query.sessionId,
  };
  const loading = ElLoading.service({
    lock: true,
    text: "订单提交中...",
    background: "rgba(0, 0, 0, 0.7)",
  });
  // params.receiveParam.district = params.receiveParam.district
  // params.receiveParam.districtCode = params.receiveParam.districtCode
  try {
    // 保存地址
    unref(isNewAddress) && await saveAddress({ 
      ...params.receiveParam, 
      isDefault: 0,
    })

    const orderData = await submitOrderApi(params);
    console.log(orderData, "orderData");
    // if (paymentMethod.value === "wepay") {
    //   微信支付
    //   const payData = await payApi(orderData.data.id);
    //   console.log(payData, "payData");
    // } else if (paymentMethod.value === "alipay") {
    // 支付宝支付
    const payData = await payApi({
      id: orderData.id,
      channel: paymentMethod.value,
      platform: "PCWEB",
    });
    console.log(payData, "payData");

    if (payData) {
      unref(payQrCodeDialogRef)?.show({
        payType: unref(paymentMethod),
        price: orderData.withoutPay,
        qrCodeUrl: payData,
        validityTime: 180
      })
    } else {
      ElMessage.error('支付失败')
    }
    loading.close();
  } catch (error) {
    ElMessage.error(error.message || '支付失败')
    console.log(error, "error");
  } finally {
    loading.close();
  }
};
const payTimeoutHandle = () => {
  ElMessageBox.confirm('支付过期请重新支付', { showCancelButton: false })
}
</script>

<style lang="scss" scoped>
.configuration-page {
  background: #ffffff;
  padding: 0;
}

.header {
  position: relative;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .back-btn {
    display: flex;
    align-items: center;
    cursor: pointer;

    .back-text {
      font-size: 16px;
      color: #333;
    }
  }

  .page-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

.content {
  box-sizing: border-box;
  height: calc(100vh - 64px);
  overflow-y: auto;
  display: flex;
  background-color: #f0f2f5;
  gap: 20px;

  .error-message {
    margin-bottom: 20px;
  }

  h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 700;
  }

  h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .selections-container {
    padding-top: 20px;
    width: 100%;
    background-color: #fff;
    width: 70%;

    .selections-info {
      display: flex;
      flex-direction: column;
      height: 100%;

     .codes-info {
       padding: 0 20px;
       margin-top: 8px;
       display: grid;
       grid-template-columns: max-content 1fr max-content;
       align-items: center;
       gap: 10px;
     }

     .codes-label {
       font-size: 13px;
       color: #6b7280;
     }

     .codes-box {
       padding: 6px 10px;
       border-radius: 6px;
       background: #f7f8fa;
       border: 1px solid #e5e7eb;
       color: #111827;
       font-size: 13px;
       font-family: SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
       line-height: 1.4;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       cursor: pointer;
       transition: background 0.2s ease, border-color 0.2s ease;
     }

     .codes-box:hover {
       background: #f3f4f6;
       border-color: #d1d5db;
     }
     .selections-list {
       flex: 1;
       height: 100%;
       overflow-y: auto;
       padding: 0 20px;

       .selection-item {
         .step-name {
           font-size: 18px;
           font-weight: 600;
           color: #333;
           line-height: 26px;
           text-align: left;
           padding-left: 20px;
           border-left: 4px solid #ff4d4f;
           margin-bottom: 10px;
         }

         .item-info {
           cursor: pointer;
           background: #f8f9fa;
           border: 1px solid #e9ecef;
           border-radius: 8px;
           margin: 0 20px;
           padding: 16px;
           margin-top: 8px;
           display: flex;
           align-items: center;
           text-align: left;
           gap: 20px;

           .item-name {
             font-size: 18px;
             font-weight: 600;
             color: #333;
             margin-bottom: 8px;
           }

           .item-step {
             font-size: 14px;
             color: #666;
             margin-bottom: 4px;
           }

           .item-price {
             font-size: 14px;
             color: #666;
           }
         }
       }
     }

     .total-info {
       width: 100%;
       text-align: right;
       display: flex;
       justify-content: flex-end;
       align-items: center;
       background: #fff2f0;

       .total-price {
         font-size: 24px;
         font-weight: bold;
         color: #ff4d4f;
         padding: 20px;
         border-radius: 8px;
       }
     }
   }

   .empty-state {
     flex: 1;
     margin-top: 100px;
     text-align: center;
   }
 }

 .address-info {
   padding-top: 20px;
   flex: 1;
   background: #fff;
   display: flex;
   flex-direction: column;

   .address-info-header {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 0 20px;
   }

   .address-box {
     padding: 0 20px;
     flex: 1;
     overflow-y: auto;

     :deep(.el-form) {
       .el-form-item {
         .el-form-item__label {
           font-size: 16px;
           color: #000;
         }
       }
     }
   }

   .address-list {
     flex: 1;
     overflow-y: auto;

     .address-item {
       background: #fff;
       border: 2px solid #e8e8e8;
       border-radius: 8px;
       padding: 16px;
       margin-bottom: 12px;
       cursor: pointer;
       transition: all 0.3s ease;

       &:hover {
         border-color: #007c4f;
         box-shadow: 0 2px 8px rgba(0, 124, 79, 0.1);
       }

       &.active {
         border-color: #007c4f !important;
         background: #f0f9f6 !important;
       }

       &.active:hover {
         border-color: #007c4f !important;
         background: #f0f9f6 !important;
       }

       .address-content {
         .address-header {
           display: flex;
           align-items: center;
           margin-bottom: 8px;
           gap: 12px;

           .consignee {
             font-size: 16px;
             font-weight: 600;
             color: #333;
           }

           .phone {
             font-size: 14px;
             color: #666;
           }

           .default-tag {
             background: #007c4f;
             color: #fff;
             font-size: 12px;
             padding: 2px 6px;
             border-radius: 4px;
             margin-left: auto;
           }
         }

         .address-detail {
           font-size: 14px;
           color: #666;
           line-height: 1.5;
         }
       }
     }
   }

   .address-info-footer {
     border-top: 1px solid #e8e8e8;
     display: flex;
     flex-direction: column;
     padding: 20px;
     gap: 10px;
     font-size: 20px;
     font-weight: 600;
     color: #333;

     :deep(.el-radio-group) {
       flex-direction: column;
       align-items: flex-start;

       .el-radio__inner {
         width: 24px;
         height: 24px;

         &::after {
           width: 10px;
           height: 10px;
         }
       }

       .el-radio__label {
         font-size: 18px;
       }

       .is-checked {
         .el-radio__label {
           color: #007c4f;
         }

         .el-radio__inner {
           background-color: #007c4f;
           border-color: #007c4f;
         }
       }

       .payment-option {
         display: flex;
         align-items: center;
         gap: 12px;

         .payment-icon {
           width: 22px;
           height: 22px;
           flex-shrink: 0;
         }

         span {
           font-size: 16px;
           color: #333;
           font-weight: 500;
         }
       }
     }
   }
 }
}
</style>
